import _extends from "@babel/runtime/helpers/esm/extends";
import { css as _css } from "@emotion/react";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["className", "size"];
import { useTheme } from '@emotion/react';
import clsx from 'clsx';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const StylesContainerVariables = {
  small: 800,
  base: 1000,
  large: 1200,
  extended: 1400
};

const Container = _ref => {
  let {
    className,
    size = 'base'
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const theme = useTheme();
  return ___EmotionJSX("div", _extends({
    className: clsx('CK__Container', className),
    css: /*#__PURE__*/_css({
      width: '100%',
      margin: '0 auto',
      padding: `0 ${theme.space.base}px`,
      maxWidth: StylesContainerVariables[size],
      // Children containers should not have padding
      '.CK__Container': {
        padding: 0
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:Container;")
  }, rest));
};

export default Container;